import type { ReactNode } from "react";

type Tone = "primary" | "accent" | "secondary" | "neutral" | "success" | "danger" | "warning";

const tones: Record<Tone, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-50 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
  neutral: "bg-background-100 text-foreground-700 border-background-300",
  success: "bg-primary-50 text-primary-700 border-primary-200",
  danger: "bg-accent-50 text-accent-700 border-accent-200",
  warning: "bg-warning-50 text-warning-800 border-warning-200",
};

interface BadgeProps {
  children: ReactNode;
  tone?: Tone;
  icon?: string;
  className?: string;
}

/** Pastille d'état (statut, mention, rôle) : une ligne, jamais coupée. */
export default function Badge({ children, tone = "neutral", icon, className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex max-w-full items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium ${tones[tone]} ${className}`}
    >
      {icon && (
        <span className="w-3.5 h-3.5 flex items-center justify-center shrink-0" aria-hidden="true">
          <i className={`${icon} text-xs leading-none`}></i>
        </span>
      )}
      <span className="truncate">{children}</span>
    </span>
  );
}
